export default __webpack_public_path__ + "bc5433a25043ba8f77b25b7f28341d6b.svg";